import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface Option {
  id: string;
  name: string;
}

interface DynamicSelectProps {
  options: Option[];
  placeholder?: string;
  defaultValue?: string;
  onSelect: (value: string) => void;
}

export const DynamicSelect: React.FC<DynamicSelectProps> = ({
  options = [], // Default to an empty array
  placeholder = "",
  defaultValue = "",
  onSelect,
}) => (
  <Select defaultValue={defaultValue} onValueChange={onSelect}>
    <SelectTrigger className="w-[120px] text-xs ">
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      <SelectGroup>
        {options.map((option) => (
          <SelectItem key={option.id} value={option.name}>
            {option.name}
          </SelectItem>
        ))}
      </SelectGroup>
    </SelectContent>
  </Select>
);
